
import { storeUtil } from "@/store";
import { computed, defineComponent, watch } from "vue";
import { useRouter } from "vue-router";
import BananoShape from "@/components/UI/BananoShape.vue";
import Sidebar from "@/components/Sidebar.vue";

export default defineComponent({
  name: "Dashboard",
  components: {
    BananoShape,
    Sidebar,
  },

  setup() {
    const router = useRouter();

    const seed = computed(storeUtil.getters.seed);
    const accounts = computed(storeUtil.getters.accounts);

    // on accounts load push to default route if none
    watch(accounts, (accs) => {
      if (accs.length && router.currentRoute.value.name === "Dashboard") {
        router.push({
          name: "Account",
          params: { banAddress: accs[0].address },
        });
      }
    });

    return {
      seed,
      accounts,
    };
  },
});
